export const selectCurrency = (state) => state.currency;
export const selectChannel = (state) => state.channel;
export const selectAuth = (state)=>state.authenticated;